import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "M13.4134 13.7899V23H9.36405V13.7899H6V10.0555H9.36405V8.69675C9.36405 3.65237 11.3809 1 15.6483 1C16.9565 1 17.2836 1.21967 18 1.39867V5.09246C17.1979 4.94601 16.9721 4.86465 16.1389 4.86465C15.1499 4.86465 14.6204 5.15754 14.1376 5.73521C13.6548 6.31287 13.4134 7.31361 13.4134 8.74556V10.0636H18L16.7696 13.7981H13.4134V13.7899Z" }, null, -1)
  ])))
}
export default { render: render }